/* @ngInject */
export default function ShutoffThresholdPanelService($q, $sails, $log, EquipmentInfoService) {
  const service = this;

  service.shutoffThresholdModel = {};

  service.getEquipmentFromIds = getEquipmentFromIds;
  service.getStatusForEquipment = getStatusForEquipment;
  service.setNewThreshold = setNewThreshold;
  service.updateCurrentReadingFromEvent = updateCurrentReadingFromEvent;
  service.setSchedule = setSchedule;
  service.toggleSchedule = toggleSchedule;
  service.deleteModel = deleteModel;

  function getEquipmentFromIds(equipmentIds) {
    return EquipmentInfoService.getFullEquipment(equipmentIds)
      .then((equipment) => {
        _.forEach(equipment, (eq) => {
          service.shutoffThresholdModel[eq.id] = { equipment: eq };
        });
        return equipment;
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function getStatusForEquipment(equipmentId) {
    return $sails.get(`/equipment/${equipmentId}/statuses/getAllStatuses/`)
      .then(success => success.data)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function setNewThreshold(equipment, newWarningThreshold, newShutoffThreshold) {
    const updateObj = {
      updates: {
        settings: angular.copy(equipment.settings)
      }
    };

    if (newWarningThreshold) {
      updateObj.updates.settings.warnValue = newWarningThreshold;
    }
    if (newShutoffThreshold) {
      updateObj.updates.settings.shutoffValue = newShutoffThreshold;
    }

    return $sails.put(`/equipment/${equipment.id}`, updateObj)
      .then((success) => {
        if (success.data && success.data.length) {
          _.forEach(success.data, (eq) => {
            service.shutoffThresholdModel[eq.id].equipment = eq;
            EquipmentInfoService.updateEquipment(eq);
          });
        }
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function updateCurrentReadingFromEvent(eventObj) {
    if (eventObj.data && eventObj.data.hasOwnProperty('currentReading')) {
      service.shutoffThresholdModel[eventObj.equipment.id].currentReading = eventObj.data.currentReading;
    }
  }

  function setSchedule(equipment, schedule) {
    return $sails.post(`/equipment/${equipment.id}/actions/setSchedule/`, {
      schedule,
      id: equipment.id
    })
      .then(({ data }) => {
        service.shutoffThresholdModel[equipment.id].schedule = data.payload;
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function toggleSchedule(equipment, disena) {
    return $sails.post(`/equipment/${equipment.id}/actions/${disena.toLowerCase()}leSchedule/`, {
      id: equipment.id
    })
      .then(() => {
        service.shutoffThresholdModel[equipment.id].enabled = disena === 'Enab';
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function deleteModel() {
    service.shutoffThresholdModel = {};
  }
}
